import styled, { css } from "styled-components";

export const StyledStory = styled.div`
    background: ${p => p.theme.c.light};
    position: relative;
    h2 {
        font-size: 38px;
        text-transform: uppercase;
        text-align: center;

        ${p =>
            p.theme.md.only(css`
                font-size: 32px;
            `)}

        ${p =>
            p.theme.sm.max(css`
                font-size: 30px;
                margin-bottom: 10px;
            `)}
    }


    display: flex;
    flex-direction: column;
    font-size: 24px;
    font-weight: 300;
    color: ${p => p.theme.c.boost};
    box-shadow: 0 -8px 6px -4px ${p => p.theme.c.blackShadow2};

    ${p =>
        p.theme.sm.max(css`
            padding-bottom: 12px;
        `)}

    p {
        margin: auto;
        padding: 0 0 12px;
        line-height: 1.5;
        text-align: justify;
        ${p =>
            p.theme.md.min(css`
                width: 850px;
            `)}
        ${p =>
            p.theme.lg(css`
                width: 950px;
                margin-bottom: 30px;
            `)}

        ${p =>
            p.theme.sm.max(css`
                padding: 0 32px;
                font-size: 18px;
            `)}

        ${p =>
            p.theme.md.only(css`
                font-size: 20px;
            `)}

        ${p =>
            p.theme.xs(css`
                padding: 0 16px;
                br {
                    display: none;
                }
                hyphens: manual;
            `)}

    }
`;
